import React, { useEffect, useState } from 'react';

const CacheRefresh = () => {

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/meta.json?ts=' + Date.now(), { cache: 'no-store' });
        const data = await response.json();
        const latestVersion = data.version;

        const storedVersion = localStorage.getItem('app_version');

        if (storedVersion !== latestVersion) {
          console.log(`Version changed: ${storedVersion} → ${latestVersion}`);

          // Clear storage
          localStorage.clear();
          sessionStorage.clear();

          // Unregister service workers
          /*
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            registrations.forEach(reg => reg.unregister());
          }*/

          // Store new version
          localStorage.setItem('app_version', latestVersion);

          // Reload to fetch fresh assets
          window.location.reload(true);
        } else {
          console.log(`No Version Change: ${storedVersion} → ${latestVersion}`);
        }
      } catch (error) {
        console.error('Failed to fetch version info:', error);
      }
    };

    checkVersion();
  }, []);

  return;
};

export default CacheRefresh;